export function RealEstateReInvest() {
  return <div> Hello World</div>;
}
